import Pusher from "pusher-js";

export const getClient = (token) =>
  new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    authEndpoint: `${process.env.REACT_APP_API_URL}/api/pusher/auth`,
    auth: { headers: { Authorization: `Bearer ${token}` } },
  });
